import React, { Component } from 'react';
import { connect } from 'react-redux';

import { ANY_ERROR } from '../../../../action/user_action_types';
import HeaderAdminpanel from "../../common/HeaderAdminpanel"; 
import SideBar from '../../common/sideBar';
import { history } from '../../../../history/history';
import Pagination from '../../../common/Pagination';
import NoData from '../../common/NoData';
import { getAdminData } from '../../../../util/util';
import moment from 'moment';
import ViewStationsModal from '../../audioadminmanagment/ViewStationsModal';
class CampaignsListComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1, limit: 10, totalRecords: 0,
      allCampaigns: [], campaignArr: [],
      adminData: getAdminData(),
      showstationlist: false,
      currentStations: [],
    }
  };

  //Get all campaign
  componentWillMount = () => {
    if(this.props.location.state && this.props.location.state.sallerCampaigns) {
      let { page }= this.state;
      let { sallerCampaigns }= this.props.location.state;
      this.setState({ allCampaigns: sallerCampaigns, totalRecords: sallerCampaigns.length }, ()=> {
        this.getAllCampaigns(page);
      });
    }
    else {
      history.push('/admin/salesuser');
    }
  }

  //Set all campaign bassed on page to state
  getAllCampaigns = page => {
    let { limit, allCampaigns }= this.state;
    let start= (page - 1) * limit;
    let campaignArr= allCampaigns.slice(start, start + 10);
    this.setState({ page, campaignArr });
  }
  hideshowstations = (e) => {
    this.setState({ showstationlist: !this.state.showstationlist });
  };
  //Redirect to route bassed on path
  goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  }

  //Return the table for campaign
  render() {
    let { campaignArr, adminData,totalRecords, page, limit } = this.state;
    let indexNum = (page - 1) * limit;
    return (
      <div className="dashboardContainer">
        <HeaderAdminpanel/>
        <div className="dashboardContainer-inner">
               <section id="sidebar">
                 <SideBar />          
                </section>
          <section id="dashboard-rightContainer" className="dashboard-manageSales" >

            <div className="container-head">
              <div className="dashboard-breadcrumb">
                Sales User Management |<span className="breadcrumb-active fct-breadcrumb">Sales User List</span>
              </div>
              {/* <div className={((!searchName && user.length === 0)) ? "search_camp none" : "search_camp"}>
                <input type="text" placeholder="search" onChange={getSearch} />
                <span><img src="/assets/images/search.png" /></span>
              </div> */}
            </div>
            <div className={campaignArr.length === 0 ? "dashboard-content userListing-dashboard bg-white table-responsive none" :
              "dashboard-content userListing-dashboard bg-white table-responsive"}>
              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Campaign ID</th>
                    <th>Campaign Name</th>
                    <th>Product Category</th>
                    <th>Status</th>
                    <th>Package Type</th>
                    <th>Station</th>
                    <th>Price</th>
                    <th>Action</th>

                    
                  </tr>
                </thead>
                <tbody>

                  {campaignArr.map((campaign, index) => {
                    indexNum++;
                    return (
                      <tr key={index}>
                        <td>{indexNum}</td>
                        <td>{campaign._id}</td>
                        <td>{campaign.name}</td>
                        <td>{campaign.product}</td>
                        <td>{campaign.status}</td>
                        <td>{campaign.type}</td>
                        <td>{campaign.station.includes(",") ? (
                                      <a
                                        onClick={(e) => {
                                          this.setState({
                                            currentStations: campaign.station.split(
                                              ","
                                            ),
                                            showstationlist: true,
                                          });
                                        }}
                                      >
                                        Multiple (
                                        {campaign.station.split(",").length})
                                      </a>
                                    ) : (
                                      campaign.station
                                    )}</td>
                        <td>{campaign.totalCost}</td>
                        <td className="txt-cntr">
                          <a>
                            <span className="tooltip-reject view-tooltip">
                              <img src="/assets/images/eye.png" className="reject-approved-img reject-png"
                                onClick={() => this.goToRoute("campaignData", campaign, '/admin/salesuser/campaign/view')} />
                              <span>View</span>
                            </span>
                          </a>
                        </td>
                      </tr>
                    )
                  })
                  }
                </tbody>
              </table>
              <div className="paginationTable">
                {totalRecords > 10 &&
                  <Pagination getAllData={this.getAllCampaigns} totalRecords={totalRecords} />
                }
              </div>
             
            </div>
            {campaignArr.length === 0 ?
              <NoData /> : null}
          </section>

        </div>
        {this.state.showstationlist && (
          <ViewStationsModal
            stations={this.state.currentStations}
            closeAction={this.hideshowstations}
          />
        )} 
      </div>
    );
  };
};

const mapDispatchToProps = dispatch => {
  return {
    showError: error => dispatch({
      type: ANY_ERROR,
      payload: error
    })
  };
};
export default connect(null, mapDispatchToProps)(CampaignsListComp);



// WEBPACK FOOTER //
// ./web/components/admin/users/salesUser/CampaignsList.jsx